export function getPlatformNameFromAgencyCode(agencyCode: string): string {
  const atlasString = "AGA";
  if (agencyCode.startsWith(atlasString) || agencyCode.startsWith("CLL")) {
    return "";
  } else {
    return `${atlasString} | `;
  }
}
